import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CONFIRM_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { getConfirmationModal } from '@commons/Modals/ConfirmationModal';

const WARNING_ICON = '/images/inpulse/warning-white-small.svg';

/**
 * Confirmation modal of the "Retirer du catalogue" actions. The wording spells out the order-side
 * impacts since the removal also rewrites the draft orders.
 *
 * @param {boolean} isSingleProduct - Whether a single row is removed rather than the selection
 * @param {Function} onCancel - Called when the modal is dismissed, to drop the pending removal
 * @param {Function} onConfirm - Called once the removal is confirmed
 */
export const getRemoveProductsModal = ({ isSingleProduct, onCancel, onConfirm }) => {
  const title = i18next.t(
    isSingleProduct
      ? 'EXTERNAL_CLIENTS.CATALOG.REMOVE_MODAL_TITLE'
      : 'EXTERNAL_CLIENTS.CATALOG.REMOVE_SELECTION_MODAL_TITLE',
  );
  return {
    ...getConfirmationModal({
      type: 'warning',
      title,
      icon: WARNING_ICON,
      content: i18next.t('EXTERNAL_CLIENTS.CATALOG.REMOVE_MODAL_CONTENT'),
      actions: [
        {
          ...GENERIC_MODAL_CANCEL_BUTTON(),
          handleClick: onCancel,
        },
        {
          ...GENERIC_MODAL_CONFIRM_BUTTON(),
          handleClick: onConfirm,
        },
      ],
    }),
    handleCloseCleanUp: onCancel,
  };
};

/**
 * Confirmation modal shown once a source client has been picked in the clone modal: the clone
 * replaces the whole current catalog, so the destructive part is confirmed before calling the API.
 *
 * @param {Function} onCancel - Called when the modal is dismissed, to drop the picked source client
 * @param {Function} onConfirm - Called once the clone is confirmed
 */
export const getCloneConfirmationModal = ({ onCancel, onConfirm }) => ({
  ...getConfirmationModal({
    type: 'warning',
    title: i18next.t('EXTERNAL_CLIENTS.CATALOG.CLONE_CONFIRMATION_TITLE'),
    icon: WARNING_ICON,
    content: i18next.t('EXTERNAL_CLIENTS.CATALOG.CLONE_CONFIRMATION_CONTENT'),
    actions: [
      {
        ...GENERIC_MODAL_CANCEL_BUTTON(),
        handleClick: onCancel,
      },
      {
        ...GENERIC_MODAL_CONFIRM_BUTTON(),
        handleClick: onConfirm,
      },
    ],
  }),
  handleCloseCleanUp: onCancel,
});
